import { useCallback, useEffect, useMemo, useRef, useState } from 'react'

const _clampVolume = (volume: number) => {
  return Math.min(Math.max(volume, 0), 100) / 100.0
}

export const usePlayAudio = (selectedAudio: string, selectedVolume = 0.8) => {
  const audioRef = useRef<HTMLAudioElement | null>(null)
  const [playing, setPlaying] = useState(false)

  const togglePlay = () => {
    if (audioRef.current) {
      if (playing) {
        audioRef.current.pause()
      } else {
        audioRef.current.play()
      }
      setPlaying(!playing)
    }
  }

  const handleAudioFinished = () => {
    setPlaying(false)
  }

  const loadAudio = useCallback(async () => {
    const audioModule = await import(
      `../../../assets/audio/${selectedAudio}.mp3`
    )

    const audioElement = new Audio(audioModule.default)

    audioElement.volume = _clampVolume(selectedVolume)
    audioElement.addEventListener('ended', handleAudioFinished)

    audioRef.current = audioElement
  }, [selectedAudio, selectedVolume, audioRef])

  useEffect(
    () => {
      loadAudio()

      return () => {
        if (audioRef.current) {
          audioRef.current.removeEventListener('ended', handleAudioFinished)
          audioRef.current.pause()
          audioRef.current = null
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedAudio, selectedVolume],
  )

  return useMemo(
    () => ({ playing, togglePlay }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [playing],
  )
}
